import { tryCatch } from '@thalesrc/js-utils';

import { dateSort } from '../../../../utils';
import HSApi from '../../HSApi';
import { AnalysisFileUploadResult } from './analysis-file-upload.result';

export async function getAnalysisFileUpload(employeeId: string): Promise<AnalysisFileUploadResult[]> {
  const [error, res] = await tryCatch(HSApi.get<AnalysisFileUploadResult[]>(`/analysis/imported-files?employeeId=${employeeId}`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return dateSort(res.data);
}

export async function deleteAnalysisFileUpload(id: AnalysisFileUploadResult['id']) {
  const [err, res] = await tryCatch(HSApi.delete(`/analysis/imported-files/${id}`));

  if (err) {
    console.log(err); // tslint:disable-line:no-console
  }

  return res.data;
}
